import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import RevealOnScroll from '../WrapComponents/RevealOnScroll.jsx';
import PageTransition from '../WrapComponents/PageTransition.jsx';
import axiosInstance from '../Axiosintances/Axiosinstance.jsx';

const Projects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        const response = await axiosInstance.get('/service/api/v1/public_projects');
        setProjects(response.data);
      } catch (error) {
        console.error("Error fetching projects:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchProjects();
  }, []);

  return (
    <PageTransition>
      <div className='bg-white dark:bg-gray-950 transition-colors duration-300 min-h-screen'>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 md:py-20">

          <RevealOnScroll className="text-center mb-10 md:mb-20">
            <h1 className="text-4xl md:text-5xl font-bold mb-4 tracking-tight text-gray-900 dark:text-white">
              Our Projects
            </h1>
            <p className="text-gray-500 dark:text-gray-400 max-w-2xl mx-auto text-lg">
              Explore some of our recent work that demonstrates our commitment to quality and innovation.
            </p>
          </RevealOnScroll>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {loading ? (
              <div className="col-span-full text-center py-20">
                <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-black dark:border-white mx-auto mb-4"></div>
                <p className="text-gray-500 dark:text-gray-400">Loading projects...</p>
              </div>
            ) : projects.length > 0 ? (
              projects.map((project, idx) => (
                <RevealOnScroll
                  key={project.id || idx}
                  delay={idx * 100}
                  className="h-full"
                  direction="up"
                >
                  <div className="group bg-white dark:bg-gray-900 rounded-2xl overflow-hidden border border-gray-100 dark:border-gray-800 shadow-sm hover:shadow-2xl dark:hover:shadow-black/50 transition-all duration-500 hover:-translate-y-2 h-full flex flex-col">

                    <div className="h-64 overflow-hidden relative">
                      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors z-10 duration-500" />
                      <div className="relative  overflow-hidden shadow-2xl group">
                        <img
                          src={project.image}
                          alt={project.name}
                          className="w-full h-auto object-contain"
                        />
                      </div>
                    </div>

                    <div className="p-8 flex-grow flex flex-col">
                      <div className="flex justify-between items-start mb-2">
                        <h3 className="text-xl font-bold text-gray-900 dark:text-white group-hover:text-black dark:group-hover:text-gray-200 transition-colors">
                          {project.name}
                        </h3>
                      </div>

                      {project.category && (
                        <p className="text-xs font-bold text-gray-400 dark:text-gray-500 uppercase tracking-wider mb-4">
                          {project.category}
                        </p>
                      )}

                      <p className="text-sm text-gray-500 dark:text-gray-400 leading-relaxed mb-6 flex-grow whitespace-pre-line">
                        {window.innerWidth < 640
                          ? (project.description?.slice(0, 300) + (project.description?.length > 300 ? "...." : ""))
                          : (project.description?.slice(0, 350) + (project.description?.length > 350 ? "........." : ""))
                        }
                      </p>

                      <div className="flex flex-wrap gap-3 mt-auto">
                        <Link
                          to={`/projectsview/${project.id}`}
                          className="flex-1 min-w-[120px] bg-black dark:bg-white text-white dark:text-black text-sm font-bold py-3 rounded-xl hover:bg-gray-800 dark:hover:bg-gray-200 transition-all transform hover:scale-105 active:scale-95 shadow-md flex justify-center items-center gap-1 group/btn"
                        >
                          View Details
                        </Link>
                        <Link
                          to="/contact"
                          className="flex-1 min-w-[120px] border-2 border-black dark:border-white text-black dark:text-white text-sm font-bold py-3 rounded-xl hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-all transform hover:scale-105 active:scale-95 flex justify-center items-center"
                        >
                          Contact
                        </Link>
                      </div>
                    </div>

                  </div>
                </RevealOnScroll>
              ))
            ) : (
              <div className="col-span-full text-center py-20">
                <p className="text-gray-500 dark:text-gray-400">No projects found.</p>
              </div>
            )}
          </div>
          {/* 
          <RevealOnScroll className="mt-20 flex justify-center gap-4">
            <button className="bg-black dark:bg-white text-white dark:text-black px-10 py-4 rounded-full font-bold hover:bg-gray-800 dark:hover:bg-gray-200 transition-all transform hover:scale-105 active:scale-95 shadow-lg">
              View All Projects
            </button>
          </RevealOnScroll> */}

        </div>
      </div>
    </PageTransition>
  );
};

export default Projects;
